import { useToken } from "@gluestack-style/react";
import BookAServiceForm from "components/form/BookAServiceForm";
import { SiteSelect } from "components/form/SiteSelect";
import Breadcrumbs from "components/general/Breadcrumbs";
import Container from "components/general/Container";
import DismissableContent from "components/general/DismissableContent";
import PageHeader from "components/general/Headers/PageHeader";
import InfoBox from "components/general/InfoBox";
import ScrollContainer from "components/general/ScrollContainer";
import Section from "components/general/Section";
import Seo from "components/general/Seo";
import { SiteSelectButton } from "components/general/SiteSelectButton";
import { Box, Button, H1, H3, HStack, ParagraphSmall, Text, Typography } from "components/ui";
import { sk } from "date-fns/locale";
import { AlertCircle, Book } from "lucide-react-native";
import React from "react";
import { useGetEquipmentQuery } from "store/abcoApi";
import * as Yup from "yup";

export default function Page() {
	const [site, setSite] = React.useState<any>(null);

	return (
		<ScrollContainer>
			<Container>
				<Seo title="Book a service" description="Book a service for your equipment" />
				<PageHeader title="Book a service" />
				{/* <Box paddingHorizontal={48} gap={24} zIndex={10}>
					<Box maxWidth={500}>
						<SiteSelect onSelect={setSite} allowedTypes="Site" />
					</Box>
					{!site && (
						<Box width="$full">
							<DismissableContent icon={<AlertCircle />} variant="warning">
								<Text>Please select a site to continue.</Text>
							</DismissableContent>
						</Box>
					)}
				</Box> */}

				{/* <Box
					sx={{
						paddingHorizontal: 16,
						"@md": {
							paddingHorizontal: 48,
						},
					}}
					paddingVertical={32}
				>
					<Box pb={20}>
						<Breadcrumbs />
					</Box>
				</Box> */}
				<Box alignItems="center">
					<Box flex={1} gap={24} width={"$full"}>
						<BookAServiceForm site={site} />
					</Box>
				</Box>
			</Container>
		</ScrollContainer>
	);
}
